import axiosInstance from '../axiosInstance';

/**
 * One slice of an event's audit log. `from` and `to` are ISO timestamps; the
 * server clamps the portal access view to its 12-month retention window.
 */
export const list = (eventId, { view = 'changes', from = '', to = '' } = {}) =>
  axiosInstance
    .get(`/event/${encodeURIComponent(eventId)}/audit`, {
      params: {
        view,
        ...(from ? { from } : {}),
        ...(to ? { to } : {})
      }
    })
    .then((response) => response.data);

/**
 * Record a browser-performed activity (QR print, log or draw export). This is
 * fire-and-forget: a failed audit write must never block the action itself.
 */
export const reportActivity = (eventId, body = {}) => {
  if (!eventId || !body.operation) return;
  axiosInstance
    .post(`/event/${encodeURIComponent(eventId)}/audit/activity`, body)
    .catch(() => null);
};

const auditService = { list, reportActivity };

export default auditService;
